import React, { FC } from "react";
import cn from "classnames";
import { IServiceCard } from "./types";
import { SafeHTML } from "src/components/SafeHTML";

interface Props extends IServiceCard {}

export const ServiceCart: FC<Props> = ({
  icon: Icon,
  iconClassName,
  title,
  titleClassName,
  description,
  className,
  overlayClassName,
}) => (
  <div className={overlayClassName}>
    <div
      className={cn(
        "flex flex-col items-start justify-center gap-3 h-full w-full p-2.5 lg:px-10 lg:py-6 4xl:gap-5 4xl:py-8.5 4xl:px-12.5",
        className
      )}
    >
      <Icon
        className={cn(
          "flex w-9 h-9 md:hidden 4xl:flex md:w-12.5 md:h-12.5",
          iconClassName
        )}
      />
      <div className="flex items-center justify-between w-full gap-2">
        <h4
          className={cn(
            "break-words text-lg 4xl:text-24 flex-1",
            titleClassName
          )}
        >
          {title}
        </h4>
        <Icon
          className={cn(
            "hidden md:flex w-12.5 h-12.5 4xl:hidden",
            iconClassName
          )}
        />
      </div>
      <SafeHTML
        html={description}
        className="text-inherit text-10 leading-tight xs:text-xs 4xl:text-base"
      />
    </div>
  </div>
);
